import { styled } from '../jss-style';

import iconStyle from './icon';

const useIconStyle = styled(iconStyle, 'icon');

export { iconStyle, useIconStyle };

export default useIconStyle;
